



























import { Component, Vue, Watch, Provide } from 'vue-property-decorator';
import Permission from "./component/PermissionV2.vue";
import { authorClient } from "@/api/index";
//import { CommonReq} from "@/pbjs/xcommon/module_pb";
import { GetDataPermSummaryByRoleReq, GetMenuTreeByRoleReq } from "@/pbjs/external/auth/auth_pb";
import { errorMsg, setCommon, handleResponse } from "@/utils/request";
@Component({
    name: 'system',
    components: {Permission}
})
export default class UserManagement extends Vue {
    @Provide() private placeMessage:string = "Automatic outgoing call record";
    @Provide() private filterText:string = "";
    @Provide() private activeName: string = "first";
    @Provide() private checkData: number[] = [1,2];
    @Provide() private token: string | null = "";
    @Provide() private data:any[] = [];
    @Provide() private oldSelectedNodesArray: any = [];
    @Provide() private permissionData: any[] = [];
    @Provide() private roleid: any;
    @Provide() private isShowPermission: boolean = false;
    @Provide() private defaultProps: any = {
        children: 'kidsList',
        label: 'name',
        id: 'id'
    }

    @Watch("filterText")
    onFilterTextChanged(val: string) {
        const ref: any = this.$refs.tree;
        ref.filter(val);
    }

    private created() {
        this.token = localStorage.getItem("token");
        this.listRole();
    }

    private filterNode(value: string, data: any) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
    }

    private handleRoleIdentityClick(data: any) {
        this.roleid = data.id;
        this.getPermissionListAPI(data.id);
    }

    private refreshData() {
        this.getPermissionListAPI(this.roleid);
    }

    private addPropertyEdit(data: any) {
        data.forEach((item: any) => {
            item.edit = false;
            item.label = item.rolename;
            item.id = item.roleid;
            item.children = item.kidrolesList;
            if (item.kidrolesList) {
                this.addPropertyEdit(item.kidrolesList);
            }
        });
        return data;
    }
    private getPermissionListAPIFuc(data: any) {
        this.permissionData = data.treeList;
        this.oldSelectedNodesArray = [];
        this.findSelectedNodes(this.permissionData);
        this.isShowPermission = true;
    }
    private getPermissionListAPI(roleId: any) {
        let request:any = new GetMenuTreeByRoleReq();
        request.setCommonin(setCommon());
        request.setRoleid(roleId);
        authorClient.getMenuTreeByRole(request, {}, (err: any, response:any) => {
            if(response) {
                let data:any = response.toObject();
                let _fuc = this.getPermissionListAPIFuc;
                handleResponse(data, _fuc);
                // if (!data.commonout || (data.commonout.code == 0)) {
                //     this.permissionData = data.treeList;
                //     this.oldSelectedNodesArray = [];
                //     this.findSelectedNodes(this.permissionData);
                //     this.isShowPermission = true;
                // } else {
                //     this.$message.error(data.commonout.errmsg);
                // }
            }
            if(err){errorMsg(err);};
        });
    }

    private listRoleFuc(data: any) {
        this.data = data.roletreeList;
    }
    private listRole() {
        let request:any = setCommon();
        authorClient.listRole(request, {}, (err: any, response:any) => {
            if(response) {
                let data:any = response.toObject();
                let _fuc = this.listRoleFuc;
                handleResponse(data, _fuc);
                // if (!data.commonout || (data.commonout.code == 0)) {
                //     this.data = data.roletreeList;
                // } else {
                //     this.$message.error(data.commonout.errmsg);
                // }
            }
            if(err){errorMsg(err);};
        });
    }

    private findSelectedNodes(data: any) {
        data.forEach((item: any) => {
            if (item.mark == 1 && !(item.kidsList.length>0)) {
                this.oldSelectedNodesArray.push(item.id);
            }
            if(item.kidsList) {
                this.findSelectedNodes(item.kidsList);
            }
        });
    }

 }
